import axios from "axios";
import { BASE_URL } from "@/api/url";
import { store } from "@/store/store";
import commonFunc from "@/common/commonFunc";

export default class HttpClient {
  controllerName = "";
  url = "";
  intance = null;
  userId = "";
  isAuth = false;
  config = {};
  constructor(controllerName, isAuth) {
    // const keyJwt = "Jwt";
    // const resToken = localStorage.getItem(keyJwt);
    // this.headers = {
    //     'Authorization': `Bearer ${resToken}`
    // }
    this.isAuth = isAuth;
    if (isAuth) {
      const keyJwt = "Jwt";
      const resToken = localStorage.getItem(keyJwt);
      this.headers = {
        Authorization: `Bearer ${resToken}`,
      };
    }

    this.intance = axios.create({
      headers: {
        ...this.headers,
        "Content-Type": "application/json",
      },
    });
    this.controllerName = controllerName;
    if (controllerName) {
      this.url = `${BASE_URL}/${controllerName}`;
    } else if (this.controllerName) {
      this.url = `${BASE_URL}/${this.controllerName}`;
    } else {
      this.url = `${BASE_URL}`;
    }
    this.userId = localStorage.getItem("userId");
    this.config = {
      validateStatus: function (status) {
        return status >= 200 && status < 600; // Accept all status codes from 200 to 599
      },
    };
  }

  async getAsync(params, Loading = false) {
    const me = this;
    store.commit("changeLoadingStatus", Loading);
    me.settimeoutLoading();
    me.setIntance();
    if (!params.url) params.url = me.url;
    if (params.queries) {
      params.url += `?${me.getQueryString(params.queries)}`;
    }
    let config = this.config;
    if (params.headers) {
      config = {
        headers: params.headers,
      };
    }
    if (me.headers) {
      config.headers = { ...config.headers, ...me.headers };
    }

    let res = await axios
      .get(params.url, config)
      .then((res) => {
        Loading = false;
        store.commit("changeLoadingStatus", Loading);
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        store.commit("changeLoadingStatus", false);
        if (err && err.response && err.response.status == 401) {
          commonFunc.logOutClear();
        }
        if (
          err &&
          err.response &&
          (err.response.status == 400 || err.response.status == 409)
        ) {
          console.log(err.response, "err.response");
          return Promise.reject(err.response);
        }
        Promise.reject(err);
      });
    store.commit("changeLoadingStatus", Loading);
    if (res) {
      return res;
    }
    return null;
  }

  async postAsync(params, Loading = false) {
    const me = this;
    store.commit("changeLoadingStatus", Loading);
    me.settimeoutLoading();
    me.setIntance();
    if (!params) return null;
    if (!params.url) params.url = me.url;
    if (params.queries) {
      params.url += `?${me.getQueryString(params.queries)}`;
    }

    let config = this.config;
    if (params.headers) {
      config = {
        headers: params.headers,
      };
    }
    if (me.headers) {
      config.headers = { ...config.headers, ...me.headers };
    }
    config.validateStatus = function (status) {
      return status >= 200 && status < 600; // Accept all status codes from 200 to 599
    };
    let res = await axios
      .post(params.url, params.data, config)
      .then((res) => {
        Loading = false;
        store.commit("changeLoadingStatus", Loading);
        if (!res.data && res.status == 201) {
          res.data = true;
        }
        
        res.data = { ...res.data, statusCode: res.status };
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        store.commit("changeLoadingStatus", false);
        if (err && err.response && err.response.status == 401) {
          commonFunc.logOutClear();
        }
        if (
          err &&
          err.response &&
          (err.response.status == 400 || err.response.status == 409)
        ) {
          console.log(err.response, "err.response");
          return Promise.reject(err.response);
        }
        return Promise.reject(err);
      });
    store.commit("changeLoadingStatus", false);
    return res;
  }

  async putAsync(params, Loading = false) {
    const me = this;
    store.commit("changeLoadingStatus", Loading);
    me.settimeoutLoading();
    me.setIntance();
    if (!params) return null;
    if (!params.url) params.url = me.url;
    if (params.queries) {
      params.url += `?${me.getQueryString(params.queries)}`;
    }

    let config = this.config;
    if (params.headers) {
      config = {
        headers: params.headers,
      };
    }
    if (me.headers) {
      config.headers = { ...config.headers, ...me.headers };
    }
    let res = await axios
      .put(params.url, params.data, config)
      .then((res) => {
        Loading = false;
        store.commit("changeLoadingStatus", Loading);
        if (!res.data && res.status == 201) {
          res.data = true;
        }

        res.data = { ...res.data, statusCode: res.status };
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        store.commit("changeLoadingStatus", false);
        if (err && err.response && err.response.status == 401) {
          commonFunc.logOutClear();
        }
        if (
          err &&
          err.response &&
          (err.response.status == 400 || err.response.status == 409)
        ) {
          console.log(err.response, "err.response");
          return Promise.reject(err.response);
        }
        Promise.reject(err);
      });
    store.commit("changeLoadingStatus", false);
    return res;
  }

  async patchAsync(params, Loading = false) {
    const me = this;
    store.commit("changeLoadingStatus", Loading);
    this.settimeoutLoading();
    this.setIntance();
    if (!params) return null;
    if (!params.url) params.url = this.url;
    if (params.queries) {
      params.url += `?${me.getQueryString(params.queries)}`;
    }

    let config = this.config;
    if (params.headers) {
      config = {
        headers: params.headers,
      };
    }
    if (this.headers) {
      config.headers = { ...config.headers, ...this.headers };
    }
    let res = await axios
      .patch(params.url, params.data, config)
      .then((res) => {
        Loading = false;
        store.commit("changeLoadingStatus", Loading);
        if (!res.data && res.status == 201) {
          res.data = true;
        }

        res.data = { ...res.data, statusCode: res.status };
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        store.commit("changeLoadingStatus", false);
        if (err && err.response && err.response.status == 401) {
          commonFunc.logOutClear();
        }
        if (
          err &&
          err.response &&
          (err.response.status == 400 || err.response.status == 409)
        ) {
          return Promise.reject(err.response);
        }
        Promise.reject(err);
      });
    store.commit("changeLoadingStatus", false);
    return res;
  }

  async deleteAsync(params, Loading = false) {
    const me = this;
    store.commit("changeLoadingStatus", Loading);
    this.settimeoutLoading();
    this.setIntance();
    if (!params) return null;
    if (!params.url) params.url = this.url;
    if (params.queries) {
      params.url += `?${me.getQueryString(params.queries)}`;
    }

    let config = this.config;
    if (params.headers) {
      config = {
        headers: params.headers,
      };
    }
    if (this.headers) {
      config.headers = { ...config.headers, ...this.headers };
    }
    let res = await axios
      .delete(params.url, config)
      .then((res) => {
        Loading = false;
        store.commit("changeLoadingStatus", Loading);
        if (!res.data && res.status == 201) {
          res.data = true;
        }

        res.data = { ...res.data, statusCode: res.status };
        return Promise.resolve(res.data);
      })
      .catch((err) => {
        store.commit("changeLoadingStatus", false);
        if (err && err.response && err.response.status == 401) {
          commonFunc.logOutClear();
        }
        Promise.reject(err);
      });
    store.commit("changeLoadingStatus", false);
    return res;
  }

  getQueryString(query) {
    if (!query) return "";
    let queryArr = [];
    Object.keys(query).forEach((key) => {
      if (query[key] || query[key] == 0) {
        queryArr.push(`${key}=${query[key]}`);
      }
    });
    return queryArr.join("&");
  }

  setIntance() {
    if (this.isAuth) {
      const keyJwt = "Jwt";
      const resToken = localStorage.getItem(keyJwt);
      this.headers = { Authorization: `Bearer ${resToken}` };
    }
    // this.intance = axios.create({
    //   headers: {
    //     // 'Authorization': `Bearer ${resToken}`
    //   },
    // });
  }

  settimeoutLoading() {
    setTimeout(() => {
      store.commit("changeLoadingStatus", false);
    }, 10000);
  }
}
